import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { SavedQueryDTO } from "../../../types/SavedQuery";
import type { RootState } from "../../store";

interface SelectedSavedQueryState {
  savedQuery?: SavedQueryDTO | undefined;
}

export const selectSavedQuery = createSelector(
  (state: RootState) => state,
  (state) => state.selectedSavedQuery,
);

export const selectedSavedQuerySlice = createSlice({
  name: "savedQuery",
  initialState: { savedQuery: undefined } as SelectedSavedQueryState,
  reducers: {
    updateSelectedSavedQuery: (state, action: PayloadAction<SavedQueryDTO>) => {
      state.savedQuery = action.payload;
    },
    clearSelectedSavedQuery: (state) => {
      state.savedQuery = undefined;
    },
  },
});

export const { updateSelectedSavedQuery, clearSelectedSavedQuery } =
  selectedSavedQuerySlice.actions;
